import { RiferimentiPosizioneVO } from "./riferimenti-posizioneVO";
import { ClassificaVO } from "./classificaVO";
import { DocumentoVO } from "./documentoVO";
import { TempiConservazioneVO } from "./tempi-conservazioneVO";
import { StrutturaVO } from "./strutturaVO";
import { SettoreVO } from "./settoreVO";
import { CampoSpecificoFascicolazioneVO } from "./campo-specifico-fascicolazioneVO";
import { CampoSpecificoFascicoloVO } from "./campo-specifico-fascicoloVO";
import { TipoSupportoDocumentoEnum } from "../enum/tipo-supporto-documento-enum";
import { UtenteVO } from "./utenteVO";
import { MetadatiProtocolloVO } from "./metadati-protocolloVO";
import { VisibilitaFascicoloVO } from "./visibilita-fascicoloVO";
import { MetadatiRepertorioVO } from "./metadati-repertorioVO";
import { MetadatiFascicoloVO } from "./metadati-fascicoloVO";
import { LinguaVO } from "./linguaVO";
import { DatiReportorioManualiVO } from "./dati-repertorio-manualiVO";
import { DatiPersonaliVO } from "./dati-personaliVO";

export class UnitaDocumentariaVO {
  id: string;
  idArea: string;
  tipo: TipoSupportoDocumentoEnum;
  oggetto: string;
  cartaceo: boolean;
  documentoPrimario: DocumentoVO = new DocumentoVO();
  tempiConservazione: TempiConservazioneVO = new TempiConservazioneVO();
  riferimentoPosizione: RiferimentiPosizioneVO = new RiferimentiPosizioneVO();
  allegati: DocumentoVO[] = new Array<DocumentoVO>();
  dataUltimaModifica: string;
  dataInserimentoFascicolo: string;
  dataInserimento: string;
  dataArchiviazione: string;
  dataManuale: number;
  stato: string;
  inseritoDa: UtenteVO = new UtenteVO();
  classifica: ClassificaVO = new ClassificaVO();
  classificaAggiuntiva: ClassificaVO = new ClassificaVO();
  struttura: SettoreVO;
  repertoriato: boolean;
  metadatiRepertorio: DatiReportorioManualiVO = new DatiReportorioManualiVO();
  copiaUd: Boolean;
  idCopia: string;
  segnaturaArchivistica: string;
  lingue: LinguaVO[];

  // tslint:disable-next-line:max-line-length
  //   riservato: boolean;
  collocazioneFisica: string;
  metadatiProtocollo: MetadatiProtocolloVO[] = new Array<
    MetadatiProtocolloVO
  >();
  visibilitaElemento: VisibilitaFascicoloVO[] = new Array<
    VisibilitaFascicoloVO
  >();
  firmatario: UtenteVO;
  importDaGescor: boolean;
  isArrivo: boolean;
  importata: boolean;
  bloccatoDa: UtenteVO;
  alertClassifica: boolean = false;
  idCorrispondenza: string;
  idAttribuzione: string;
  metadatiFascicolo: MetadatiFascicoloVO;
  personale: boolean;
  altraDenominazione: string;
  dimensioni: number;
  struttureAggiuntive: SettoreVO[];
  datiPersonali: DatiPersonaliVO;
  privato: boolean;
  riservato: boolean;
  inFirma: Boolean;
}
